$('[data-action="toggle-search"]').on('click', function(e) {
    $('.header-search').toggleClass('is-visible');
    if ($('.header-search').hasClass('is-visible')) {
        $('.header-search__input').focus();
    }
});

$('.toggle--faq').on('click', function(e) {
    $(this).next().toggleClass('is-visible');
    if ($(this).next().hasClass('is-visible')) {
        $(this).attr('aria-expanded', 'true');
    } else {
        $(this).attr('aria-expanded', 'false');
    }
});

$('.product-gallery__thumbnail').on('click', function(e) {
    var thumb_id = $(this).attr('data-media-id');
    $('.product-gallery__media').attr('aria-hidden', 'true');
    $('.product-gallery__media[data-media-id="'+thumb_id+'"]').attr('aria-hidden', 'false');
});

// $('button.header__menu-disclosure').on('click', function(e) {
//   e.preventDefault();
//   var follow_link = $(this).attr('data-follow-link');
//   window.location.href = follow_link;
// });

$('.header__primary-nav-item').on('focus mouseenter', function(e) {
  $('.mega-menu').removeClass('is-visible');
  if(e.type == 'mouseenter') {
    $(this).find('.header__menu-disclosure').attr('aria-expanded', 'true');
    $(this).find('.mega-menu').addClass('is-visible');
  }
});
$('.header__primary-nav-item').on('mouseleave', function(e) {
  $(this).find('.header__menu-disclosure').attr('aria-expanded', 'false');
  $(this).find('.mega-menu').removeClass('is-visible');
});

$('button.header__menu-disclosure').on('keydown click', function(e) {
  if(e.type == 'keydown') {
    if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      console.log('test');

      if($(this).attr('aria-expanded') == 'true') {
        $(this).attr('aria-expanded', 'false');
        $(this).next().removeClass('is-visible');
      } else {
        $(this).attr('aria-expanded', 'true');
        $('.mega-menu').removeClass('is-visible');
        $(this).next().addClass('is-visible');
      }
    }
  } else {
    if($(this).attr('aria-expanded') == 'true') {
      $(this).attr('aria-expanded', 'false');
      $(this).next().removeClass('is-visible');
    } else {
      $(this).attr('aria-expanded', 'true');
      $('.mega-menu').removeClass('is-visible');
      $(this).next().addClass('is-visible');
    }
  }
});
$('.header__primary-nav-item a.h6').on('focus', function(e) {
  $('.mega-menu').removeClass('is-visible');
});


$('#mobile-nav-button').on('click', function(e) { 
  setTimeout(focusClose, 500);
});

function focusClose() {
  const customElement = document.querySelector('header-sidebar');
  const shadowRoot = customElement.shadowRoot;
  const buttonInsideShadow = shadowRoot.querySelector('#sidebar-menu-close');
 if (buttonInsideShadow) {
    buttonInsideShadow.focus();
  }
}

$('.header-sidebar__linklist-next').on('click', function(e) { 
  const cont = $(this).attr('aria-controls');
  setTimeout(() => {
    $('#'+cont+' .header-sidebar__back-button').focus();
  }, 500);
});

$('.variant-picker__option-values input[type="radio"]').on('click', function(e) {
    selectRadioButton(e.target);
});
$('.variant-picker__option-values').on("keyup", function(e) {
  switch(e.key) {
    case 'ArrowUp':
    case 'ArrowLeft':
    case 'ArrowDown':
    case 'ArrowRight':
    selectRadioButton(e.target);
    break;
  }
});

var radioButtons = document.querySelectorAll('.variant-picker__option-values input[type="radio"]');  
function selectPreviousRadioButton(radioButton) {
  var index = Array.prototype.slice.call(radioButtons).indexOf(radioButton);
  
  if(index > 0) {
    selectRadioButton(radioButtons[index - 1]);
  } else {
    selectRadioButton(radioButtons[radioButtons.length - 1]);
  }
}

function selectNextRadioButton(radioButton) {
  var index = Array.prototype.slice.call(radioButtons).indexOf(radioButton);
  
  if(index < radioButtons.length - 1) {
    selectRadioButton(radioButtons[index + 1]);
  } else {
    selectRadioButton(radioButtons[0]);
  }
}

function selectRadioButton(radioButton) {
  // Deselect all other radio buttons
  radioButtons.forEach(function(otherRadioButton) {
    otherRadioButton.setAttribute('tabindex', -1);
    otherRadioButton.setAttribute('aria-checked', false);
  });
  
  // Select the provided radio button
  radioButton.setAttribute('tabindex', 0);
  radioButton.setAttribute('aria-checked', true);
  radioButton.focus();

  const title = radioButton.nextElementSibling.getAttribute('data-vtitle')
  document.getElementById('selected-shade').innerHTML = title;

  const available = radioButton.nextElementSibling.getAttribute('data-available');
  if (available == 'false') {
    document.getElementById('btnclick').classList.add('hidden');
    document.querySelector('.BIS_trigger').style.display = 'block';
  } else {
    document.getElementById('btnclick').classList.remove('hidden');
    document.querySelector('.BIS_trigger').style.display = 'none';
  }
  
}